import { useTranslation } from 'react-i18next';
import { Shield } from 'lucide-react';
import { FC, ReactElement, useMemo } from 'react';
import moment from 'moment';
import classnames from 'classnames';
import useStore from '../../hooks/store/useStore';
import { REDUX_STORE_SLICES } from '../../services/exports/Constants';

interface Props {
  className?: string;
}

export enum TrustLabelPeriod {
  LESS_THAN_1_MONTH = '< 1 month',
  ONE_MONTH_OR_MORE = '>= 1 month',
  SIX_MONTHS_OR_MORE = '>=6 months',
}

const TrustLabel: FC<Props> = ({ className }): ReactElement => {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Labels:TrustLabel' });
  const { company } = useStore<REDUX_STORE_SLICES.INITIAL_DATA>(REDUX_STORE_SLICES.INITIAL_DATA);

  const period = useMemo(() => {
    if (!company?.live_from) {
      return null;
    }

    const liveFrom = moment(company.live_from);
    const now = moment();

    const diffInMonths = now.diff(liveFrom, 'months', true);

    if (diffInMonths >= 6) return TrustLabelPeriod.SIX_MONTHS_OR_MORE;

    if (diffInMonths >= 1) return TrustLabelPeriod.ONE_MONTH_OR_MORE;

    return TrustLabelPeriod.LESS_THAN_1_MONTH;
  }, [company?.live_from]);

  return (
    period && (
      <div className={classnames(container, className)}>
        <Shield className="w-4 h-4 text-success flex-shrink-0" />
        <p className="text-xs text-muted-foreground">{t(`labels.${period}`)}</p>
      </div>
    )
  );
};

export default TrustLabel;

const container = 'bg-muted/50 rounded-lg px-3 py-2 flex items-center gap-2';
